import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import Slider from 'rc-slider';
import Price from '../Price/Price.js';

const TooltipLabel = ({ currency , renderNumber , value , side  })=>/*#__PURE__*/ React.createElement("div", {
        className: `tooltip__label tooltip__label--${side}`,
        "data-t": `tooltip-label-${side}`
    }, currency ? /*#__PURE__*/ React.createElement(Price, {
        value: renderNumber(value),
        currency: currency,
        centAmount: false
    }) : renderNumber(value))
;
// needed for new rc slider that doesn't discern different value types between
// sliders with one, or more handles (the latter being called "range" sliders)
// takes a function that accepts number[] and protects it from simple number input
const rangeProtect = (func)=>(value)=>{
        if (func && Array.isArray(value)) func(value);
    }
;
const RangeSlider = ({ min , max , defaultValue =[] , value , onChange , onAfterChange , currency , renderNumber =(v)=>v
  })=>/*#__PURE__*/ React.createElement("div", {
        className: "range-slider",
        "data-t": "range-slider"
    }, /*#__PURE__*/ React.createElement(Slider, swcHelpers.extends({}, value ? {
        value
    } : {
        defaultValue
    }, {
        range: true,
        min: min,
        max: max,
        onAfterChange: rangeProtect(onAfterChange),
        onChange: rangeProtect(onChange),
        allowCross: false
    })), /*#__PURE__*/ React.createElement("div", {
        className: "tooltip"
    }, /*#__PURE__*/ React.createElement(TooltipLabel, {
        currency: currency,
        value: (value || defaultValue)[0],
        renderNumber: renderNumber,
        side: "left"
    }), /*#__PURE__*/ React.createElement(TooltipLabel, {
        currency: currency,
        value: (value || defaultValue)[1],
        renderNumber: renderNumber,
        side: "right"
    })))
;

export { RangeSlider };
//# sourceMappingURL=RangeSlider.js.map
